import { NgModule } from '@angular/core';
import { BrowserModule, } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ToolbarModule } from 'primeng/toolbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DataViewModule,DataViewLayoutOptions } from 'primeng/dataview';
import { RatingModule } from 'primeng/rating';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TagModule } from 'primeng/tag';
import { IEnvironment, SynergyCoreModule } from 'synergy-core';
import { environment } from 'src/environments/environment';
import { SynergySpinnerComponent } from './components/synergy-spinner/synergy-spinner.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { PasswordForgottenComponent } from './components/password-forgotten/password-forgotten.component';
import { DiscountComponent } from './components/discount/discount.component';
import { StepsModule } from 'primeng/steps';
import { SynergyFooterComponent } from './components/synergy-footer/synergy-footer.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { VerifyAccountComponent } from './components/verify-account/verify-account.component';
import { BranchComponent } from './components/branch/branch.component';
import { TaxComponent } from './components/tax/tax.component';
import { WarehouseComponent } from './components/warehouse/warehouse.component';
import { ProviderComponent } from './components/provider/provider.component';
import { SourceComponent } from './components/source/source.component';
import { CustomerComponent } from './components/customer/customer.component';
import { ContactComponent } from './components/contact/contact.component';
import { SubCategoryComponent } from './components/sub-category/sub-category.component';
import { ProductComponent } from './components/product/product.component';
import { CategoryComponent } from './components/category/category.component';
import { UserComponent } from './components/user/user.component';
import { ItemComponent } from './components/item/item.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { UtilitiesComponent } from './components/utilities/utilities.component';
import { SettingsComponent } from './components/settings/settings.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { ProfileComponent } from './components/profile/profile.component';
import { HelpComponent } from './components/help/help.component';
import { OrdersComponent } from './components/orders/orders.component';
import { DeliveryComponent } from './components/delivery/delivery.component';
import { ClientComponent } from './components/client/client.component';
import { ProductBundleComponent } from './components/product-bundle/product-bundle.component';

export const uri: IEnvironment = {
  baseBillingURL: environment.baseBillingURL,
  baseEBillingURL: environment.baseEBillingURL,
  baseMailingURL: environment.baseMailingURL,
  baseSharedURL: environment.baseSharedURL,
  baseAuthenticationURL: environment.baseAuthenticationURL,
  baseOrganizationURL: environment.baseOrganizationURL
}

@NgModule({
  declarations: [
    AppComponent,
    SynergySpinnerComponent,
    LoginComponent,
    RegisterComponent,
    DashboardComponent,
    PasswordForgottenComponent,
    DiscountComponent,
    SynergyFooterComponent,
    WelcomeComponent,
    VerifyAccountComponent,
    BranchComponent,
    TaxComponent,
    WarehouseComponent,
    ProviderComponent,
    SourceComponent,
    CustomerComponent,
    ContactComponent,
    CategoryComponent,
    SubCategoryComponent,
    ProductComponent,
    UserComponent,
    ItemComponent,
    ProductDetailComponent,
    MaintenanceComponent,
    UtilitiesComponent,
    SettingsComponent,
    PaymentsComponent,
    ProfileComponent,
    HelpComponent,
    OrdersComponent,
    DeliveryComponent,
    ClientComponent,
    ProductBundleComponent
  ],
  imports: [
    BrowserModule, 
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ConfirmDialogModule,
    TableModule,
    ToastModule,
    DialogModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    ToolbarModule,
    ProgressSpinnerModule,
    StepsModule, RatingModule,DataViewModule,DropdownModule,TagModule,
    SynergyCoreModule.forRoot(uri)
  ],
  providers: [MessageService, ConfirmationService],
  bootstrap: [AppComponent]
})
export class AppModule { }